import { useEffect } from 'react'

type CircleProps = {
  map: google.maps.Map
  lat: number
  lng: number
  fillColor: string
  radius?: number
}

/**
 * Componente React para desenhar um círculo no Google Maps.
 * O círculo é criado e removido automaticamente conforme as props mudam.
 * Não renderiza nada visualmente no React, apenas manipula o mapa.
 */
export default function Circle({ fillColor, lat, lng, map, radius = 50 }: CircleProps) {
  useEffect(() => {
    // Não faz nada se o mapa não estiver disponível
    if (!map) return

    // Cria o círculo no mapa
    const circle = new google.maps.Circle({
      center: { lat, lng },
      clickable: false,
      fillColor,
      fillOpacity: 0.6,
      map,
      radius,
      strokeWeight: 0,
    })

    // Remove o círculo do mapa ao desmontar ou atualizar dependências
    return () => {
      circle.setMap(null)
    }
  }, [map, lat, lng, fillColor, radius])

  // Não renderiza nada no DOM
  return null
}
